import * as ng from 'angular';
import * as uib from 'angular-ui-bootstrap';
import * as _ from 'underscore';

import { ModalSelectorDelegate } from "../../shared";
import { SurveyItemsApiService } from '../survey';

// List of demographic fields which are extra inputs on top of survey items
// in the survey summary report
const demographicItems = [
   { id: 'age_category', label: 'Age Category' },
   { id: 'gender', label: 'Gender' },
   { id: 'state', label: 'State' },
   { id: 'country', label: 'Country' }
];

export class SurveySelectorController implements ModalSelectorDelegate {
   static $inject = ['$uibModal', 'surveyItemsApi', 'session'];

   constructor(
      private $modal:uib.IModalService,
      private surveyItemsApi:SurveyItemsApiService,
      private session
   ) { }

   title = 'Select Survey Questions';
   multiSelect = true;
   templateUrl = 'survey-selector-rows.html';

   ngModelCtrl:ng.INgModelController;

   load(search:string):ng.IPromise<{total:number, list:any[]}> {
      return this.surveyItemsApi.list(this.session.getBrand().id).then((data:any[]) => {
         // modal selector component expects objects to have `id` property
         // make new objects using survey item key/name for `id`
         let items = _.map(data, si => { return { id: si.key, label: si.description.en }; })
         items = demographicItems.concat(items);

         if (search) {
            search = search.toLowerCase();
            let words = _.reject(search.split(' '), w => w === '');
            items = _.filter(items, i => _.every(words, w =>
               i.label.toLowerCase().indexOf(w) >= 0));
         }

         return {
            total: items.length,
            list: items
         };
      });
   }

   open() {
      this.$modal.open({
         component: 'modalSelector',
         resolve: {
            selected: () => this.selected ? this.selected.split(',') : [],
            delegate: () => this
         }
      }).result.then(result => {
         this.ngModelCtrl.$setViewValue(result ? result.join(',') : null);
      });
   }

   get buttonText():string {
      if (this.selected) {
         return `${this.selected.split(',').length} Questions Selected`;
      }

      return this.title;
   }

   get selected():string {
      return this.ngModelCtrl.$modelValue;
   }
}

ng.module('e360').component('surveySelector', {
   templateUrl: require('./survey-selector.html'),
   controller: SurveySelectorController,
   require: {
      ngModelCtrl: 'ngModel'
   }
})
